import BaseButton from 'app/components/common/BaseButton';
import { LABEL_STYLE } from 'app/components/presentation/forms/Labels';
import ChevronDown from 'app/components/svgs/ChevronDown';
import { GREY_B, WHITE_A, WHITE_C } from 'app/constants/Colors';
import { buttonReset } from 'app/constants/Styles';
import { useCss } from 'app/utils/css';
import React, { FunctionComponent, ReactNode, useState } from 'react';

interface IProps {
  title: string;
  contents: ReactNode;
}

/**
 * Expandable box with title and content. Shows the first line
 * when not expanded.
 */
const TermsBox: FunctionComponent<IProps> = ({ contents, title }) => {
  const [expanded, setExpanded] = useState(false);
  const css = useCss();

  return (
    <div>
      <BaseButton
        type="button"
        aria-label={'expand'}
        onClick={() => setExpanded(!expanded)}
        className={css('expandBaseButton', {
          ...buttonReset,
          cursor: 'pointer',
          width: '100%',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        })}
      >
        <div className={css('title', LABEL_STYLE)}>{title}</div>
        <ChevronDown height="9px" width="9px" strokeWidth="5" color={GREY_B} flipped={expanded} />
      </BaseButton>
      {expanded ?
        <div
          className={css('expandedBox', {
            maxHeight: '10em',
            overflow: 'auto',
            backgroundColor: WHITE_A,
            padding: '5px',
          })}
        >
          {contents}
        </div> :
        <div
          className={css('collapsedBox', {
            height: '1.3em',
            overflow: 'hidden',
            background: `linear-gradient(to bottom, ${WHITE_A}, ${WHITE_C})`,
            padding: '5px',
          })}
        >
          {contents}
        </div>
      }
    </div>
  );
};

export default TermsBox;
